<template>
  <el-dialog title="Adicionar clientes" :append-to-body="true" center :visible.sync="dialog" width="80%">
    <el-form>
      <el-form-item :label="$t('cliente')">
        <CustomerList v-model="ruleForm.customer" ref="customerList" :customerType="0" :multiple="false" @selected="updated" />
      </el-form-item>
      <el-form-item label="Endereços">
        <CustomerAddressList v-model="ruleForm.address" :customer="ruleForm.customer" @selected="selected" />
      </el-form-item>
      <el-form-item label="Após">
        <el-select v-model="ruleForm.markers">
          <el-option v-for="item in tableMarkers" :key="item.id" :label="item.formatted" :value="item.id">
            <span style="float: left">{{ item.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.formatted }}</span>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="default" @click.stop.prevent="dialog = false">Cancelar</el-button>
      <el-button type="primary" @click.stop.prevent="add">Adicionar</el-button>
    </span>
  </el-dialog>      
</template>

<script>
import { RouteService } from "@/services/umov/route.services";
import CustomerAddressList from "../../../register/customer/CustomerAddressList.vue";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import { GeocoderService } from "@/services/umov/geocoder.services";
import { gmapApi } from "vue2-google-maps";

export default {
  name: "AddRouteDestination",
  components: {
    CustomerList,
    CustomerAddressList
  },
  computed: {
    google: gmapApi,
  },
  data() {
    return {
      ruleForm: {
        customer: "",
        address: null,
        markers: "",
      },
      dialog: false,
      id: "",
      tableMarkers: [],
    }
  },
  methods: {
    updated(customer) {
      this.ruleForm.customer = customer;
    },
    selected(addressData) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      console.log("addressData", addressData)
      GeocoderService.geocoder({ ...addressData, customer: vm.ruleForm.customer })
        .then((data) => {
          console.log("geocode data", data)
          if (!data) {
            return this.$message({ type: "error", duration: 5000, message: `Endereço não encontrado para o Cliente ${customer.name}.` });
          }
          const { lat, lng } = data.geometry;
          vm.ruleForm.address = {
            customer: vm.ruleForm.customer,
            name: data.name,
            formatted: data.address.formatted,
            zipcode: data.address.zipcode,
            number: data.address.number,
            lat,
            lng,
          };
        })
        .catch((error) => {
          this.$message({ type: "error", duration: 5000, message: error });
        })
        .finally(() => loading.close());
    },
    fetch() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      RouteService.get(vm.id)
        .then((response) => {
          vm.tableMarkers = response.markers.filter(x => x.status === "waiting");
          vm.dialog = true;
        })
        .catch((error) => {
          return this.$message({ type: "error", duration: 5000, message: error });
        })
        .finally(() => loading.close());
    },
    add() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      RouteService.addCustomer({
        id: vm.ruleForm.markers,
        address: vm.ruleForm.address,
      })
      .then((response) => {
        this.dialog = false;
        vm.$message({
          type: "success",
          message: "Endereço adicionado com sucesso",
        });
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      })
      .finally(() => loading.close());
    },
    open(id) {
      this.id = id;
      this.fetch();
    }
  },
}
</script>